import React, { useRef } from "react";
import JoditEditor from "jodit-react";

const RichTextBox = ({setDescriptionValue, defaultValue = ''}) => {
  const editor = useRef(null);
  return <JoditEditor ref={editor} value= {defaultValue} onChange={content => setDescriptionValue(content)}/>;
};

export default RichTextBox;
